import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';

import { NotificationService } from '../../../../shared/api/hscan/notification';
import { useUserState } from '../../../../shared/hooks/accountHook';
import {
  useNotificationServiceList,
  useUpdateUserNotificationServiceList,
  useUserNotificationServiceList,
} from '../../../../shared/hooks/notificationHook';
import { StyledTextField } from '../../common/components/Slot/TextFieldSlot';
import { SuccessModal } from '../../common/components/SuccessModal/SuccessModal';

import {
  CardContainer,
  CardHeading,
  InnerFrame,
  CheckboxContainer,
  CheckboxButton,
  Label,
  TextContainer,
  CardText,
  SaveButton,
  ButtonText,
  LabelContainer,
  CheckboxInnerContainer,
} from './styledComponent';

const NotificationServiceComponent = ({ isMobile, t }: any) => {
  const [user] = useUserState();

  const [selectedServices, setSelectedServices] = useState<string[]>([]);
  const { data: userData } = useUserNotificationServiceList();
  useEffect(() => {
    setSelectedServices(userData?.map(u => u.serviceId) ?? []);
  }, [userData]);

  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const { mutate: saveUserData } = useUpdateUserNotificationServiceList({
    onSuccess: () => setOpenSuccessModal(true),
  });
  const handleSaveButtonClick = () => {
    saveUserData(selectedServices);
  };

  const { data: options } = useNotificationServiceList();

  const handleCheckboxChange = (channel: string) => {
    const index = selectedServices.indexOf(channel);

    if (index === -1) {
      setSelectedServices([...selectedServices, channel]);
    } else {
      const updatedServices = [...selectedServices];
      updatedServices.splice(index, 1);
      setSelectedServices(updatedServices);
    }
  };

  return (
    <>
      <CardContainer>
        <CardHeading>{t('channel')}</CardHeading>
        <InnerFrame mobile={isMobile ? true : undefined}>
          {options &&
            options.map((notification: NotificationService, index: number) => (
              <CheckboxContainer
                key={`checkbox-${index}`}
                mobile={isMobile ? true : undefined}>
                <CheckboxInnerContainer>
                  <CheckboxButton
                    type="checkbox"
                    id={`checkbox-${index}`}
                    name="notification-channel"
                    checked={selectedServices.includes(notification.serviceId)}
                    onChange={() =>
                      handleCheckboxChange(notification.serviceId)
                    }
                    disabled={!notification.available}
                  />
                  <LabelContainer mobile={isMobile ? true : undefined}>
                    <Label htmlFor={`checkbox-${index}`}>
                      {t(`notificationService.${notification.serviceId}`)}
                    </Label>
                  </LabelContainer>
                </CheckboxInnerContainer>
                {notification.serviceId === 'whatsapp' && (
                  <StyledTextField
                    type="text"
                    readOnly
                    placeholder={`${t('placeholderText')}`}
                    value={user?.telecom ? user.telecom : `${t('inputText')}`}
                  />
                )}
              </CheckboxContainer>
            ))}
          <TextContainer>
            <CardText>
              <Trans
                t={t}
                i18nKey="notificationText"
                components={{ b: <strong /> }}
              />
            </CardText>
          </TextContainer>
          <SaveButton
            selected={selectedServices.length > 0}
            onClick={
              selectedServices.length > 0 ? handleSaveButtonClick : undefined
            }>
            <ButtonText selected={selectedServices.length > 0}>
              {t('save')}
            </ButtonText>
          </SaveButton>
        </InnerFrame>
      </CardContainer>
      <SuccessModal
        open={openSuccessModal}
        onClose={() => setOpenSuccessModal(false)}
        onClickConfirm={() => setOpenSuccessModal(false)}
        content={`${t('success.message')}`}
      />
    </>
  );
};

export default NotificationServiceComponent;
